import type { MailboxInfo } from 'owa-client-types';
import { getStore } from '../store/store';

export function getAccountOptions(): MailboxInfo[] {
    return getStore().accountOptions;
}
